module.exports = __webpack_public_path__ + "static/img/UBC老师_Mark.90c4f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_Mark.png
// module id = ePXl
// module chunks = 0